import styled from 'styled-components';

export const Main = styled.main`
  width: 100%;
  flex: 1;
  box-sizing: border-box;
`;

export const Wrapper = styled.section`
  position: relative;
  max-width: 1312px;
  height: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-left: 24px;
  padding-right: 24px;
`;

export const Container = styled.div`
  position: relative;
  max-width: 1312px;
  height: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-left: 24px;
  padding-right: 24px;
  display: flex;
  align-items: center;
`;

export const TitleContent = styled.div`
  width: 100%;
  padding: 2rem 0rem;
`;

export const TitlePage = styled.div`
  h1 {
    font-size: 1.5rem;
    font-weight: 700;
    text-transform: uppercase;
    pointer-events: none;
    user-select: none;
  }

  hr {
    margin-top: 0.5rem;
    width: 50px;
    border: 2px solid ${props => props.theme.primaryColor};
    background-color: ${props => props.theme.primaryColor};
    border-radius: 2px;
    transition: 0.3s ease-in-out;
  }

  &:hover > hr {
    width: 100%;
  }
`;

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
